const o = {
  name: "Slovakia",
  dimensions: { width: 20, height: 21 },
  content: `
    <g>
      <path d="M18.4001 19.5875C18.4001 17.8875 17.1001 16.5875 15.4001 16.5875C14.6001 16.5875 14.0001 16.8875 13.4001 17.3875C13.0001 15.8875 11.6001 14.7875 10.0001 14.7875C8.4001 14.7875 7.0001 15.8875 6.6001 17.3875C6.0001 16.8875 5.4001 16.5875 4.6001 16.5875C2.9001 16.5875 1.6001 17.8875 1.6001 19.5875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10 1.58752V14.5875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.40015 5.1875H13.6001" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.2002 8.78748H14.8002" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as Slovakia
};
